import { render, staticRenderFns } from "./ProfileScreen.vue?vue&type=template&id=6a38b052&scoped=true&"
var script = {}
import style0 from "./ProfileScreen.vue?vue&type=style&index=0&id=6a38b052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a38b052",
  null
  
)

export default component.exports